import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteReviewItem, GetAssetsReviewImage, ReviewGetItem, ReviewUpdateItem, UploadFileModel } from 'src/app/models/review';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ReviewManagementService } from 'src/app/services/review-management.service';

@Component({
  selector: 'app-update-reviews-product',
  templateUrl: './update-reviews-product.component.html',
  styleUrls: ['./update-reviews-product.component.css']
})
export class UpdateReviewsProductComponent implements OnInit {

  Loader: boolean = false;
  reviewsId: number;
  tinyMCEkey: string;
  file: any;
  imageUrl: any;
  getReviewsdetails: ReviewGetItem = new ReviewGetItem();
  updateReviews: ReviewUpdateItem = new ReviewUpdateItem();
  uploadFileArray: UploadFileModel= new UploadFileModel();
  getReviewsImgItem: DeleteReviewItem = new DeleteReviewItem();
  reviewImageLoader: boolean = false;
  getAssetsReviewImage: Array<GetAssetsReviewImage> = new Array<GetAssetsReviewImage>();
  selectedActive: string;

  constructor(private alertify: AlertifyService, private _reviewUploadImageService: ReviewManagementService, private _reviewService: ReviewManagementService, private router: ActivatedRoute, private route: Router) { }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.reviewsId = + param.id;
    });
    this.getReviewsById();
    this.getReviewsImage();
  }

  getReviewsById() {
    this.Loader = true;
    this._reviewService.getReviewsById(this.reviewsId).subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.getReviewsdetails = responseBody.responseData;
      this.updateReviews.name = this.getReviewsdetails.name;
      this.updateReviews.title = this.getReviewsdetails.title;
      this.updateReviews.comments = this.getReviewsdetails.comments;
      this.updateReviews.IsActive = this.getReviewsdetails.isActiveValue; 
      this.selectedActive = this.updateReviews.IsActive ? "1" : "0";
    });
    this.Loader = false;
  }

  onSubmit() {
    if (this.updateReviews.name == undefined || this.updateReviews.name == null || this.updateReviews.name == "") {
      this.alertify.error("Reviewer Name is required");
      return;
    }
    if (this.updateReviews.title == undefined || this.updateReviews.title == null || this.updateReviews.title == "") {
      this.alertify.error("Review Title is required");
      return;
    }
    if (this.updateReviews.comments == undefined || this.updateReviews.comments == null || this.updateReviews.comments == "") {
      this.alertify.error("Review Comments is required");
      return;
    }
    this.Loader = true;
    this.updateReviews.id = this.reviewsId;
    this.updateReviews.IsActive = this.selectedActive;
    this._reviewService.updateReviews(this.updateReviews)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.updateReviews = responseBody.responseData;
          if (this.uploadFileArray.Image !=undefined) {
            this.uploadFile();
          } else {
            this.alertify.success(responseBody.responseMessage);
            this.route.navigate(['reviews-listing']);
            this.Loader = false;
          }
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
      });
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
    this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.file);
    this.uploadFileArray.Image = this.file;
    this.uploadFileArray.Id = this.reviewsId;
  }

  uploadFile() {
    this.Loader = true;
    if (this.uploadFileArray.Image.name.toLowerCase().includes('.png') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpg') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpeg')) {
      this._reviewUploadImageService.uploadImage(this.uploadFileArray)
        .subscribe((rec) => {
          this.route.navigate(['reviews-listing']);
          this.getReviewsImage();
          this.Loader = false;
        });
    } else {
      this.alertify.error("Only files in .jpg, .jpeg, .png format are accepted and directories are not allowed.");
    }
  }

  getReviewsImage() {
    this.reviewImageLoader = true;
    this.getReviewsImgItem.Id = this.reviewsId;
    this._reviewUploadImageService.getReviewImage(this.getReviewsImgItem)
      .subscribe((response) => {
        let responseimage = JSON.parse(response._body)
        if (responseimage.isSuccess) {
          this.reviewImageLoader = false;
          this.getAssetsReviewImage = responseimage.responseData;
        }
      });
  }

  selectActiveProduct(selectedProductValue) {
    this.selectedActive = selectedProductValue;
  }
}
